import bugsnag from 'bugsnag-js'
import bugsnagConfig from 'config/bugsnag'
import React from 'react'
import createPlugin from 'bugsnag-react'

export const beforeSend = (report) => {
  if (bugsnagConfig.ignoreReports)
    report.ignore()
}

const bugsnagClient = bugsnag({
  ...bugsnagConfig,
  beforeSend
})

export const setBugsnagUser = (id, canonicalUserId) => {
  if (id !== bugsnagClient.user.id)
    bugsnagClient.user = {
      id,
      canonicalUserId
    }
}

export const FallbackComponent = bugsnagConfig.fallbackComponent
export const ErrorBoundary = bugsnagClient.use(createPlugin(React))

export default bugsnagClient



// WEBPACK FOOTER //
// ./src/bugsnag.js